<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

              <div class="modal-header row" style="justify-content: flex-end;">
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
                <div class="col">
                  <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 class="title">Ubah Pekerja {{ editObject.name }}</h2>
                <form>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nama<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="name" v-model="form.name" placeholder="Ketik Nama Pekerja">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Tipe Pekerja<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-model="form.labourer_type_id"
                          :options="options.laborerType.map(x => x.id)"
                          :custom-label="opt => options.laborerType.find(x => x.id == opt).name"
                          :searchable="true"
                          :close-on-select="true"
                          :multiple="true"
                          :allow-empty="true"
                          placeholder="Pilih Tipe Pekerja"
                        ></MultiSelect>
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Kategori Pekerja<span style="color: red;">*</span></label>
                        <MultiSelect
                          v-if="options.employeeType.length > 0"
                          v-model="form.employee_type_id"
                          :options="options.employeeType.map(x => x.id)"
                          :custom-label="opt => options.employeeType.find(x => x.id == opt).name"
                          :close-on-select="true"
                          :allow-empty="false"
                          placeholder="Pilih Tipe Pekerja"
                        ></MultiSelect>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Group Brand Cat</label>
                        <MultiSelect
                          v-if="options.brand.length > 0"
                          v-model="form.cat_brand_id"
                          :options="options.brand.map(x => x.id)"
                          :custom-label="opt => options.brand.find(x => x.id == opt).brand_name"
                          :close-on-select="true"
                          :allow-empty="false"
                          placeholder="Pilih Group Cat Brand"
                        ></MultiSelect>
                      </div>
                    </div>
                    
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Gaji Bulanan<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="monthly_base_salary" v-model="form.monthly_base_salary" placeholder="Ketik Gaji Bulanan Pekerja">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Bonus Mingguan<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="weekly_bonus" v-model="form.weekly_bonus" placeholder="Ketik Bonus Mingguan Pekerja">
                      </div>
                    </div>
                    
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Gaji Harian<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="daily_base_salary" v-model="form.daily_base_salary" placeholder="Ketik Gaji Harian Pekerja">
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <div class="input-group">
                        <label class="label">Tanggal Bergabung<span style="color: red;">*</span></label>
                        <flat-pickr
                          v-model="form.join_date"
                          :config="rangeConfig"
                          placeholder="Pilih Tanggal Bergabung"
                        ></flat-pickr>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mt-5" style="text-align: center">
                      <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                      <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Ubah</button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
    </div>
  </div>
</transition>
</template>

<script>
  import MultiSelect from 'vue-multiselect';

  export default {
    data () {
      return {
        options : {
          laborerType : this.$store.getters.getLaborerType,
          employeeType : [],
          brand : []
        },
        rangeConfig: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        form : {
          name : '',
          labourer_type_id : null,
          employee_type_id : '',
          monthly_base_salary : 0,
          weekly_bonus : 0,
          daily_base_salary : 0,
          join_date : '',
          cat_brand_id : ''
        }
      }
    },
    props : ['editObject'],
    components:{
      MultiSelect,
    },
    mounted () {
      this.getEmployeeType();
      this.fetchBrandCat();
      // console.log(JSON.stringify(this.editObject));
      this.form.name = this.editObject.name;
      this.form.labourer_type_id = this.editObject.labour_type.map(x=>x.labourer_type_id);
      this.form.employee_type_id = this.editObject.employee_type_id;
      this.form.monthly_base_salary = parseInt(this.editObject.monthly_base_salary);
      this.form.weekly_bonus = parseInt(this.editObject.weekly_bonus);
      this.form.daily_base_salary = parseInt(this.editObject.daily_base_salary);
      this.form.join_date = this.editObject.join_date;
      this.form.cat_brand_id = this.editObject.cat_brand_id;
    },
    watch : {

    },
    methods : {
      fetchBrandCat () {
        this.$http.get('/api/v1/masterData/cat-brand')
        .then((resp) => {
          this.options.brand = resp.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      },
      getEmployeeType () {
        this.$http.get('/api/v1/employee-types')
        .then((resp)=>{
          this.options.employeeType = resp.data.data;
        })
        .catch((err)=>{console.log(err)})
      },
      validateForm(){
        var valid = true;
        var error = [];

        if(this.form.name == '' || this.form.name == null){//Name [Required]
          valid = false;
          error.push('Nama wajib diisi');
        }

        if(this.form.labourer_type_id.length == 0 || this.form.labourer_type_id == null){//Laborer Type [Required]
          valid = false;
          error.push('Tipe pekerja wajib diisi');
        }

        if(this.form.join_date == '' || this.form.join_date == null){//Join Date [Required]
          valid = false;
          error.push('Tanggal bergabung wajib diisi!');
        }

        if((typeof this.form.monthly_base_salary == 'string'  && this.form.monthly_base_salary == '') || this.form.monthly_base_salary == null){//Gaji Bulanan [Required]
          valid = false;
          error.push('Gaji bulanan wajib diisi!');
        } else if (isNaN(this.form.monthly_base_salary)) {
          valid = false;
          error.push('Gaji bulanan harus berbentuk nomor atau bilangan!');
        }

        if((typeof this.form.weekly_bonus == 'string'  && this.form.weekly_bonus == '') || this.form.weekly_bonus == null){//Bonus Mingguan [Required]
          valid = false;
          error.push('Bonus mingguan wajib diisi!');
        } else if (isNaN(this.form.weekly_bonus)) {
          valid = false;
          error.push('Bonus mingguan harus berbentuk nomor atau bilangan!');
        }

        if((typeof this.form.daily_base_salary == 'string'  && this.form.daily_base_salary == '') || this.form.daily_base_salary == null){//Gaji Harian [Required]
          valid = false;
          error.push('Gaji harian wajib diisi!');
        } else if (isNaN(this.form.daily_base_salary)) {
          valid = false;
          error.push('Gaji harian harus berbentuk nomor atau bilangan!');
        }

        if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        else return valid;
      },
      async submitForm(){
        let vm = this;
        if(vm.validateForm()){
          this.$http.put(`/api/v1/masterData/labourer/${this.editObject.id}`, this.form)
          .then((resp)=>{
            // alert(`Partshop ${vm.form.name} has been created`);
            this.$store.dispatch('triggerAlert', [true, [`Pekerja ${vm.form.name} telah berhasil diubah`]]);
            this.$emit('updateTable');
            this.$emit('closeModal');
          })
          .catch((err)=>{
            console.log(err);
            this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
          })
        }
      },
    }
  }
</script>

<style scoped>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}
</style>
